import styled from 'styled-components'

import { StatelessDropdown } from '@sketch/components'

export const StyledCanvasContextMenu = styled(StatelessDropdown)`
  position: absolute;
`
